const en = require("~/lang/en.json");
const fr = require("~/lang/fr.json");

const messages = {
  en: en,
  fr: fr,
};

messages.en.attributes = require("~/lang/en/attributes.php");
messages.fr.attributes = require("~/lang/fr/attributes.php");

export default messages;
